import React, { useState, useContext } from "react";
import { css } from "emotion";

import { colors, textSizes, boxStyles } from "../styles/theme";
import TitleBlock from "../components/TitleBlock";
import GenericTextInput from "../components/GenericTextInput";
import GenericButton from "../components/GenericButton";
import SwitchHeader from "../components/SwitchHeader";
import { withRouter, useLocation } from "react-router-dom";
import { GlobalContext } from "../context/GlobalState";
import workspaces from "../services/api/workspaces";
import users from "../services/api/users";

const CreateWorkspace = ({ history }) => {
  const { userData, addWorkspace, updateUser } = useContext(GlobalContext);
  const [isLoading, setloading] = useState(false);
  const query = new URLSearchParams(useLocation().search);
  const planId = query.get("planId");

  const handleSubmit = (e) => {
    e.preventDefault();
    setloading(true);
    newWorkspace();
  };

  const newWorkspace = async () => {
    const workspaceData = {
      name: workspaceName,
    };

    try {
      const { data: payload } = await workspaces.create(workspaceData);
      const { updatedWorkspace: data, updatedRoles } = payload;
      const formattedWorkspaceData = {
        id: data.id,
        name: data.name,
        stripeCustomerId: data.stripeCustomerId,
        hasBillingCard: data.hasBillingCard,
        currentPlan: data.currentPlan,
      };

      const rolesObj = updatedRoles;

      const currentRole = rolesObj[data.id].role;
      const isAdmin = currentRole === "admin" || currentRole === "owner";

      updateUser({ roles: rolesObj, isAdmin });

      addWorkspace(formattedWorkspaceData);

      if (planId) {
        history.push(`/checkout/${planId}`);
      } else {
        history.push("/home");
      }
    } catch (error) {
      console.log("error bruh", error);
      setloading(false);
    }
  };

  const [workspaceName, setWorkspaceName] = useState("");
  return (
    <div className={container}>
      <SwitchHeader />
      <div className="body">
        <div className="centerBlock">
          <div className="hero">
            <TitleBlock
              title={`Welcome, ${userData.firstName}!`}
              subtitle="Create a workspace for your spotlights"
            />
          </div>
          <form className="form" onSubmit={handleSubmit}>
            <label>
              <p>WORKSPACE NAME</p>
              <GenericTextInput
                value={workspaceName}
                onValueChange={setWorkspaceName}
                needsCounter={false}
              />
            </label>
            <div className="subtext">
              <p>*Usually the name of your company or group</p>
            </div>
            <div className="buttonSection">
              <div className="button">
                <GenericButton text="Create Workspace" disabled={isLoading} />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default withRouter(CreateWorkspace);

const container = css`
  display: flex;
  flex-direction: column;

  .body {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .centerBlock {
    max-width: 650px;
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
  }

  .hero {
    max-width: 650px;
    width: 100%;
    padding: 40px 0;
  }

  .form {
    width: 80%;
    @media screen and (min-width: ${boxStyles.desktopBreak}) {
      width: 70%;
    }
    justify-content: center;

    label {
      color: ${colors.placeholderText};
      font-size: ${textSizes.normal};
    }

    .buttonSection {
      display: flex;
      flex: 1;
      justify-content: center;
      padding: 40px 0 0 0;
      .button {
        width: 80%;
        @media screen and (min-width: ${boxStyles.desktopBreak}) {
          width: 50%;
        }
      }
      button:focus {
        outline: none;
      }
    }

    .subtext {
      margin-left: 10px;
      margin-top: 5px;
      font-size: 12px;
      color: ${colors.placeholderText};
      opacity: 0.8;
    }
  }

  input:focus {
    outline: none;
  }
`;
